import { observer } from 'mobx-react-lite';
import ReelWiseSummary from './ReelWiseSummary';
import { useStore } from '../../app/stores/store';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';

interface Props {
  title: string;
}

const CommonSummaryReport = ({ title }: Props) => {
  const { commonStore, dashboardStore } = useStore();
  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        ((title === 'PL' && !commonStore.filterModeOne?.includes('RSPLSR01')) ||
          (title === 'reel' &&
            !commonStore.filterModeOne?.includes('RSRSR01'))) && (
          <UnauthorizedMessage />
        )}
      {((title === 'PL' && commonStore.filterModeOne?.includes('RSPLSR01')) ||
        (title === 'reel' &&
          commonStore.filterModeOne?.includes('RSRSR01'))) && (
        <ReelWiseSummary title={title} />
      )}
    </>
  );
};

export default observer(CommonSummaryReport);
